module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("50GmO"))).then(() => parcelRequire('fThBo'));